import { useAppNavigation } from '@euler/app/components/AppNavigationProvider';
import { Button } from '@euler/components/Button';
import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { StackActions } from '@react-navigation/core';
import { useCallback } from 'react';
import { Text } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useTheme } from 'styled-components';
import Icon404 from './assets/404.svg';

export const NotFoundScreen = wrapNavigatorScreen(
  () => {
    const navigation = useAppNavigation();
    const theme = useTheme();
    const { rpx } = useResponsiveContext();
    const onBack = useCallback(() => {
      if (navigation.canGoBack()) {
        navigation.dispatch(StackActions.pop());
      } else {
        navigation.replace('Main', {});
      }
    }, [navigation]);

    return (
      <SafeAreaView
        css={`
          flex: 1;
          justify-content: center;
          align-items: center;
        `}
      >
        <Icon404 width={rpx(350)} height={rpx(200)} />
        <Text
          css={`
            font-family: ${FontFamily.NotoSans.Bold};
            font-size: ${rpx(32)}px;
            color: #3c496b;
          `}
        >
          OOPS!
        </Text>
        <Text
          css={`
            font-family: ${FontFamily.NotoSans.Regular};
            font-size: ${rpx(14)}px;
            color: #afbec9;
            margin: ${rpx(16)}px ${rpx(32)}px;
          `}
        >
          对不起，你所访问的页面不存在，请稍候重试!
        </Text>
        <Button
          title="返回"
          onPress={onBack}
          textStyle={{ color: theme.link }}
        />
      </SafeAreaView>
    );
  },
  {
    title: 'Oops!',
    headerShown: false,
  },
);
